module.exports = __webpack_public_path__ + "ga.e178bb89ad10d0d896487b8d9da6f09c.png";